/* Remember the rendered depth as well as scroll position for collection returns. */
(()=>{
 if(!location.pathname.startsWith('/collections/'))return;
 const key=()=> 'usa-collection-return:'+location.pathname+location.search;
 const navigationType=performance.getEntriesByType('navigation')[0]?.type;
 const returning=navigationType==='back_forward' || (()=>{try{return new URL(document.referrer).origin===location.origin && new URL(document.referrer).pathname.includes('/products/');}catch{return false;}})();
 let saved=null;
 try{saved=JSON.parse(sessionStorage.getItem(key())||'null');}catch{}
 if(returning && saved && Date.now()-saved.time<3600000 && saved.url===location.pathname+location.search){
  history.scrollRestoration='manual';
  window.usaCollectionRestorePosition=()=>window.scrollTo({top:Math.max(0,Number(saved.y)||0),behavior:'instant'});
  window.usaCollectionReturn=saved;
  window.usaCollectionReturnReady=new Promise(resolve=>{window.usaCollectionReturnComplete=resolve;});
 }
 const remember=()=>{
  if(window.usaCollectionReturn)return;
  const grid=document.querySelector('#product-grid');if(!grid)return;
  try{sessionStorage.setItem(key(),JSON.stringify({url:location.pathname+location.search,y:scrollY,count:grid.querySelectorAll('.js-pagination__item').length,time:Date.now()}));}catch{}
 };
 document.addEventListener('click',event=>{const link=event.target.closest('a[href]');if(link && link.href.includes('/products/'))remember();},{capture:true});
 window.addEventListener('pagehide',remember);
})();

/**
 * Implements infinite scrolling functionality for a web component.
 *  This component loads additional content automatically as the user scrolls to the bottom of the page.
 *  It requires an element with class `.js-pagination__next-button` for fetching the next set of items.
 *
 * Usage:
 *  {%- paginate blog.articles by section.settings.items_per_page -%}
 *    <infinite-scroll data-infinite-scroll-enabled="{% if settings.pagination_style == 'infinite' %}true{% else %}false{% endif %}">
 *      <div class="js-pagination__item">One</div>
 *      <div class="js-pagination__item">Two</div>
 *      <div class="js-pagination__item">Three</div>
 *
 *      {%- if paginate.pages > 1 -%}
 *        {% render 'pagination', paginate: paginate %}
 *      {%- endif -%}
 *    </infinite-scroll>
 *  {%- endpaginate -%}
 */
if (!customElements.get('infinite-scroll')) {
  class InfiniteScroll extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    // Cleans up resources when the element is removed from the DOM
    disconnectedCallback() {
      this.destroy();
    }

    async init() {
      const version=this.initVersion=(this.initVersion||0)+1;
      this.fetchInProgress=false;
      this.collectionPrefetch=null;
      this.collectionImageWarmers=new WeakMap();
      // Measure the first screen only after the final grid/font sizes are available.
      if(location.pathname.startsWith('/collections/') || (location.pathname.startsWith('/search') || location.pathname.startsWith('/a/search/'))){
        const pageReady=document.readyState!=='loading'?Promise.resolve():new Promise(resolve=>document.addEventListener('DOMContentLoaded',resolve,{once:true}));
        await pageReady;
        const title=this.querySelector('.usa-product-name,.card__heading');
        if(title&&document.fonts){const font=getComputedStyle(title);await Promise.race([document.fonts.load(`${font.fontWeight} ${font.fontSize} ${font.fontFamily}`).catch(()=>{}),new Promise(resolve=>setTimeout(resolve,1000))]);}
        if(!this.isConnected || version!==this.initVersion)return;
      }
      // Elements involved in pagination
      this.paginationContainer = this.querySelector('.js-pagination');
      this.paginationItems = this.querySelectorAll('.js-pagination__item');
      this.nextButton = this.querySelector('.js-pagination__next-button');

      // Collection/search responses are buffered; only screen-sized initial rows
      // and one further complete row are ever inserted into the visible grid.
      const productListing=location.pathname.startsWith('/collections/') || (location.pathname.startsWith('/search') || location.pathname.startsWith('/a/search/'));
      this.collectionGrid=productListing?this.querySelector('#product-grid'):null;
      if(this.collectionGrid && this.paginationItems.length){
        this.collectionQueue=[];
        this.collectionNextURL=this.nextButton?.href || null;
        if(!this.paginationContainer){
          this.paginationContainer=document.createElement('div');
          this.paginationContainer.className='js-pagination';
          this.collectionGrid.after(this.paginationContainer);
        }
        if(!this.nextButton){
          this.nextButton=document.createElement('button');
          this.nextButton.type='button';
          this.nextButton.className='js-pagination__next-button';
          this.nextButton.textContent='Load more products';
          this.paginationContainer.append(this.nextButton);
        }
        const first=this.collectionGrid.querySelector('.js-pagination__item');
        const rowHeight=first.offsetHeight+(parseFloat(getComputedStyle(this.collectionGrid).rowGap)||0);
        const visibleRows=Math.max(1,Math.ceil(Math.min(window.innerHeight,window.innerHeight-first.getBoundingClientRect().top)/Math.max(1,rowHeight)));
        // Keep server-rendered rows: removing them collapses the footer into view.
        const count=Math.min(this.paginationItems.length,this.collectionColumns()*3);
        Array.from(this.paginationItems).slice(count).forEach(item=>{
          this.collectionQueue.push(item);item.remove();
        });
        const saved=window.usaCollectionReturn;
        if(saved && saved.url===location.pathname+location.search){
          // Recreate previously inserted rows before the browser position is restored.
          const wanted=Math.max(count,Math.min(1000,Number(saved.count)||count));
          try{
            while(this.collectionGrid.children.length+this.collectionQueue.length<wanted && this.collectionNextURL){
              await this.prefetchCollectionPage();
              if(!this.isConnected || version!==this.initVersion)return;
            }
            const fragment=document.createDocumentFragment();
            this.collectionQueue.splice(0,Math.max(0,wanted-this.collectionGrid.children.length)).forEach(item=>{
              item.classList.remove('usa-collection-ready','usa-collection-slide');fragment.append(item);
            });
            this.collectionGrid.append(fragment);
          }catch(error){console.warn('Collection return: could not restore every row',error);}
          if(!this.isConnected || version!==this.initVersion)return;
          window.usaCollectionReturn=null;
          requestAnimationFrame(()=>{
            window.scrollTo({top:Math.max(0,Number(saved.y)||0),behavior:'instant'});
            document.dispatchEvent(new Event('usa:collection-restored'));
            requestAnimationFrame(()=>{
              window.scrollTo({top:Math.max(0,Number(saved.y)||0),behavior:'instant'});
              window.usaCollectionReturnComplete?.();
            });
          });
        }
        this.paginationItems=this.querySelectorAll('.js-pagination__item');
        // Collections load the next complete row automatically near the viewport.
        this.dataset.infiniteScrollEnabled='true';
        this.classList.remove('usa-auto-load');
        this.nextButton.textContent='Load more products';
        if(!this.collectionQueue.length && !this.collectionNextURL){this.cleanupAfterLastPage();this.watchCollectionGrid();return;}
      }else if(!this.paginationContainer || !this.paginationItems.length || !this.nextButton?.hasAttribute('href')){
        if(productListing)this.watchCollectionGrid();
        return;
      }
      this.bindListeners();
      if(productListing)this.watchCollectionGrid();
      if(this.collectionQueue)this.primeCollectionBuffer(true);
    }

    watchCollectionGrid(){
        // Filters/sort replace the grid inside the existing custom element.
        this.gridObserver=new MutationObserver(()=>{
          const grid=this.querySelector('#product-grid');
          const first=grid?.querySelector('.js-pagination__item');
          if(grid!==this.collectionGrid || first!==this.paginationItems[0]){
            this.destroy();this.init();
          }
        });
        this.gridObserver.observe(this,{childList:true,subtree:true});
    }

    // Removes event listeners and stops any ongoing intervals or observers
    destroy() {
      clearInterval(this.nextButtonTimer);
      this.nextButton?.removeEventListener('click', this.clickHandler);
      this.intersectionObserver?.disconnect();
      this.gridObserver?.disconnect();
      this.collectionAbort?.abort();
    }

    // Handles the "Next" button click to fetch the next set of items
    onNextButtonClick(event) {
      event.preventDefault();
      this.fetchNextItems();
    }

    // Sets up the infinite scroll functionality
    bindListeners() {
      // Setup click handler for the "Next" button
      this.clickHandler = this.onNextButtonClick.bind(this);
      this.nextButton.addEventListener('click', this.clickHandler);

      // Initialize IntersectionObserver if infinite scrolling is enabled
      if (this.dataset.infiniteScrollEnabled === 'true') {
        if (this.collectionGrid) this.classList.add('usa-auto-load');
        this.intersectionObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              // Load more results when the "Next" button is in view
              clearInterval(this.nextButtonTimer);
              if(!this.collectionGrid)this.nextButtonTimer = setInterval(this.fetchNextItems.bind(this),1500);
              this.fetchNextItems();
            } else {
              clearInterval(this.nextButtonTimer);
            }
          });
        }, {rootMargin: this.collectionGrid ? `600px 0px` : `${window.innerHeight}px 0px`});

        this.intersectionObserver.observe(this.paginationContainer);
      }
    }

    collectionColumns() {
      const first=this.collectionGrid.querySelector('.js-pagination__item');
      if(!first)return 1;
      const gap=parseFloat(getComputedStyle(this.collectionGrid).columnGap)||0;
      return Math.max(1,Math.round((this.collectionGrid.clientWidth+gap)/(first.offsetWidth+gap)));
    }

    // Complete a row after resizing; otherwise append exactly one new row.
    collectionBatchSize() {
      const columns=this.collectionColumns();
      const remainder=this.collectionGrid.querySelectorAll('.js-pagination__item').length%columns;
      return remainder ? columns-remainder : columns;
    }

    // Fetch the next Shopify page before its rows are needed, sharing one request
    // with any foreground load. A filter/sort change invalidates the old response.
    prefetchCollectionPage() {
      if(this.collectionPrefetch)return this.collectionPrefetch;
      if(!this.collectionNextURL || !this.isConnected)return Promise.resolve();
      const version=this.initVersion, url=this.collectionNextURL;
      const controller=new AbortController();
      this.collectionAbort=controller;
      const pending=(async()=>{
        const response=await fetch(url,{signal:controller.signal});
        if(!response.ok)throw new Error(`Failed to fetch: ${response.status}`);
        const template=document.createElement('template');
        template.innerHTML=await response.text();
        if(!this.isConnected || version!==this.initVersion)return;
        const grid=template.content.querySelector('#product-grid');
        if(!grid)throw new Error('Missing product grid');
        const items=[...grid.querySelectorAll('.js-pagination__item')];
        const next=template.content.querySelector('.js-pagination__next-button[href]');
        const nextURL=next?new URL(next.getAttribute('href'),response.url).href:null;
        if(nextURL===url)throw new Error('Pagination did not advance');
        this.collectionQueue.push(...items);
        this.collectionNextURL=nextURL;
      })().finally(()=>{
        if(this.collectionPrefetch===pending)this.collectionPrefetch=null;
        if(this.collectionAbort===controller)this.collectionAbort=null;
      });
      this.collectionPrefetch=pending;
      return pending;
    }

    warmCollectionRow() {
      const width=this.collectionGrid.querySelector('.js-pagination__item')?.offsetWidth || 240;
      this.collectionQueue.slice(0,this.collectionColumns()).forEach(card=>{
        const image=card.querySelector('.card__image:not(.card__image-hover)');
        if(!image || this.collectionImageWarmers.has(image))return;
        const preload=new Image();
        preload.sizes=`${width}px`;
        if(image.srcset)preload.srcset=image.srcset;
        preload.src=image.src;
        this.collectionImageWarmers.set(image,preload);
      });
    }

    primeCollectionBuffer(force=false) {
      if(!this.collectionQueue || !this.isConnected)return;
      this.warmCollectionRow();
      if(this.collectionNextURL && (force || this.collectionQueue.length<=this.collectionColumns()*2)){
        const version=this.initVersion;
        this.prefetchCollectionPage().then(()=>{
          if(this.isConnected && version===this.initVersion)this.warmCollectionRow();
        }).catch(()=>{/* Foreground loading retains the normal retry fallback. */});
      }
    }

    async fetchCollectionBatch() {
      if (this.fetchInProgress || !this.isConnected || (!this.collectionQueue.length && !this.collectionNextURL)) return;
      const version=this.initVersion;
      this.fetchInProgress = true;
      let batchSucceeded = false;
      const originalText = this.nextButton.textContent;
      this.nextButton.setAttribute('aria-disabled', 'true');
      this.nextButton.textContent = window.strings.general.pagination.loadingText;
      try {
        const count = this.collectionBatchSize();
        while (this.collectionQueue.length < count && this.collectionNextURL) {
          await this.prefetchCollectionPage();
          if(!this.isConnected || version!==this.initVersion)return;
        }
        const fragment = document.createDocumentFragment();
        this.collectionQueue.splice(0, count).forEach(item => {
          item.classList.remove('usa-collection-ready','usa-collection-slide','scroll-trigger','animate--slide-in','usa-collection-enter','is-visible');
          fragment.append(item);
        });
        this.collectionGrid.append(fragment);
        batchSucceeded = true;
        this.paginationItems = this.querySelectorAll('.js-pagination__item');
        if (this.collectionNextURL) this.nextButton.href = this.collectionNextURL;
        if (!this.collectionQueue.length && !this.collectionNextURL) this.cleanupAfterLastPage();
        else this.primeCollectionBuffer();
        requestAnimationFrame(() => {
          if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger();
          window.renderSelects?.();
          window.loadDesktopOnlyTemplates?.();
          window.stickersReinit?.();
        });
      } catch (error) {
        if(version!==this.initVersion)return;
        this.classList.remove('usa-auto-load');
        clearInterval(this.nextButtonTimer);
        this.intersectionObserver?.disconnect();
        console.error('Failed to load collection products:', error);
      } finally {
        if(version===this.initVersion){
          this.fetchInProgress = false;
          this.nextButton.removeAttribute('aria-disabled');
          this.nextButton.textContent = originalText;
          // An observer only reports boundary crossings. Fill one row at a time
          // while the sentinel remains near the viewport after a fast scroll.
          if(batchSucceeded && this.paginationContainer.isConnected){
            requestAnimationFrame(()=>{
              if(this.isConnected && version===this.initVersion && this.paginationContainer.isConnected && this.paginationContainer.getBoundingClientRect().top < window.innerHeight + 600) this.fetchCollectionBatch();
            });
          }
        }
      }
    }

    // Fetches the next set of items and updates the DOM
    async fetchNextItems() {
      if (this.collectionQueue) return this.fetchCollectionBatch();
      if (this.fetchInProgress || !this.nextButton?.isConnected || !this.nextButton.hasAttribute('href')) return;

      let originalButtonText = this.nextButton.textContent;
      this.fetchInProgress = true;
      this.nextButton.setAttribute('aria-disabled', 'true');
      this.nextButton.textContent = window.strings.general.pagination.loadingText;

      try {
        const response = await fetch(this.nextButton.href);
        if (!response.ok) throw new Error(`Failed to fetch: ${response.statusText}`);

        const template = document.createElement('template');
        template.innerHTML = await response.text();

        // Append new items
        const newItemsHTML = Array.from(template.content.querySelectorAll('.js-pagination__item'))
          .map(item => item.outerHTML)
          .join('');
        this.paginationItems[this.paginationItems.length - 1].insertAdjacentHTML('afterend', newItemsHTML);
        const lastIndex = this.paginationItems.length
        this.paginationItems = this.querySelectorAll('.js-pagination__item');

        setTimeout(() => {
          if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger();
          window.renderSelects();
          window.loadDesktopOnlyTemplates();
          window.stickersReinit?.();

          if (document.body.classList.contains('tab-active') && window.theme?.settings.paginationLoadType === 'show_more' && this.dataset.infiniteScrollEnabled !== 'true') {
            this.paginationItems[lastIndex]?.querySelector('a')?.focus();
          }
        }, 300);

        // Update pagination controls
        this.updatePaginationControls(template);
      } catch (error) {
        this.classList.remove('usa-auto-load');
        clearInterval(this.nextButtonTimer);
        this.intersectionObserver?.disconnect();
        console.error('Failed to load new items:', error);
      } finally {
        this.fetchInProgress = false;
        this.nextButton.removeAttribute('aria-disabled');
        this.nextButton.textContent = originalButtonText;
      }
    }

    // Updates pagination controls based on the fetched content
    updatePaginationControls(template) {
      const nextPagination = template.content.querySelector('.js-pagination');
      if (nextPagination && nextPagination.querySelector('.js-pagination__next-button[href]')) {
        this.paginationContainer.innerHTML = nextPagination.innerHTML;
        this.refreshNextButton();
      } else {
        this.cleanupAfterLastPage();
      }
    }

    // Refreshes the "Next" button event listener after content update
    refreshNextButton() {
      this.nextButton.removeEventListener('click', this.clickHandler);
      this.nextButton = this.querySelector('.js-pagination__next-button');
      this.nextButton.addEventListener('click', this.clickHandler);
    }

    // Removes pagination and related elements when no more pages are available
    cleanupAfterLastPage() {
      if (this.intersectionObserver) this.intersectionObserver.disconnect();
      clearInterval(this.nextButtonTimer);
      this.paginationContainer.remove();
      document.querySelectorAll('.js-when-paginated-only').forEach(elem => elem.remove());
    }
  }

  customElements.define('infinite-scroll', InfiniteScroll);
}